import { useLocale } from "app/providers/LocaleContext";

export const useTranslation = () => {
  return useLocale();
};

export default useTranslation;
